/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable max-len */
/* eslint-disable max-lines */
import { IslandSkuData } from '../types';


export type IslandSkusDataCallback = () => Record<string, IslandSkuData>;

export interface IslandSkuOptions {
  callback?: IslandSkusDataCallback;
}

export class IslandSkuAssetData {
  private static instance: IslandSkuAssetData;
  private data: Record<string, IslandSkuData> = {};
  private callback: IslandSkusDataCallback | null = null;

  constructor (options?: IslandSkuOptions) {
  	if (options?.callback) {
  		this.callback = options.callback;
  		this.loadData();
  	}
  }

  static getInstance (options?: IslandSkuOptions): IslandSkuAssetData {
  	if (!IslandSkuAssetData.instance) {
  		IslandSkuAssetData.instance = new IslandSkuAssetData(options);
  	}
  	return IslandSkuAssetData.instance;
  }

  /**
   * Set the callback function that provides the IslandSkus data
   */
  static setCallback (callback: IslandSkusDataCallback): void {
  	IslandSkuAssetData.getInstance().callback = callback;
  	IslandSkuAssetData.getInstance().loadData();
  }

  /**
   * Get all IslandSkus data
   */
  static getData (): Record<string, IslandSkuData> {
  	return IslandSkuAssetData.getInstance().data;
  }

  /**
   * Get IslandSku data by SKU
   */
  static findBySku (sku: string): IslandSkuData | null {
  	return IslandSkuAssetData.getInstance().data[sku] || null;
  }


  /**
   * Get all SKUs
   */
  static getAllSkus (): string[] {
  	return Object.keys(IslandSkuAssetData.getInstance().data);
  }

  /**
   * Add or update an IslandSku
   */
  static addIslandSku (sku: string, componentData: IslandSkuData): void {
  	IslandSkuAssetData.getInstance().data[sku] = componentData;
  }

  /**
   * Remove an IslandSku
   */
  static removeIslandSku (sku: string): boolean {
  	const instance = IslandSkuAssetData.getInstance();
  	if (instance.data[sku]) {
  		delete instance.data[sku];
  		return true;
  	}
  	return false;
  }

  /**
   * Load data using the registered callback
   */
  private loadData (): void {
  	if (this.callback) {
  		const rawData = this.callback();
  		// Ensure msrp is a number (API might return strings)
  		this.data = Object.fromEntries(
  			Object.entries(rawData).map(([sku, item]) => [
  				sku,
  				{ ...item, msrp: Number(item.msrp) || 0 }
  			])
  		);
  	}
  }

  /**
   * Reload data
   */
  static reload (): void {
  	IslandSkuAssetData.getInstance().loadData();
  }

  /**
   * Clear all data
   */
  static clear (): void {
  	IslandSkuAssetData.getInstance().data = {};
  }
}
